import { message } from 'antd';

const API_BASE_URL = (import.meta as any).env?.VITE_API_URL || 'https://o0c80o4o8400c88w0oskkks4.coolify.dikitalsolutions.com/api';

export interface DPPItem {
  dpp_id: string;
  product_name: string;
  [key: string]: any;
}

class APIService {
  private baseURL: string;

  constructor() {
    this.baseURL = API_BASE_URL;
  }

  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const url = `${this.baseURL}${endpoint}`;
    
    try {
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
        ...options,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      message.error('API-Anfrage fehlgeschlagen');
      throw error;
    }
  }

  // Get QR Code URL for DPP
  async getQRCodeUrl(dppId: string): Promise<{ qr_url: string; dpp_id: string }> {
    return this.request<{ qr_url: string; dpp_id: string }>(`/qr/dpp/${dppId}/qr-url`);
  }

  // Get AAS Suite URL for DPP
  async getAASSuiteUrl(dppId: string): Promise<{ aas_url: string; dpp_id: string }> {
    return this.request<{ aas_url: string; dpp_id: string }>(`/qr/dpp/${dppId}/aas-url`);
  }

  // Download QR Code (URL-only)
  async downloadQRCode(dppId: string): Promise<void> {
    const url = `${this.baseURL}/qr/dpp/${dppId}/qr-code`;
    
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Download failed');
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `dpp_${dppId}_qr.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      
      message.success('QR Code heruntergeladen');
    } catch (error) {
      console.error('Download failed:', error);
      message.error('QR Code Download fehlgeschlagen');
    }
  }

  // Download QR Code with AAS integration
  async downloadAASQRCode(dppId: string): Promise<void> {
    const url = `${this.baseURL}/qr/dpp/${dppId}/qr-aas`;
    
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Download failed');
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `dpp_${dppId}_aas_qr.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      
      message.success('AAS QR Code heruntergeladen');
    } catch (error) {
      console.error('Download failed:', error);
      message.error('AAS QR Code Download fehlgeschlagen');
    }
  }

  // Get AAS Submodel JSON
  async getAASSubmodel(dppId: string): Promise<any> {
    return this.request<any>(`/qr/dpp/${dppId}/aas-submodel`);
  }

  // Test API connection
  async testConnection(): Promise<{ message: string; status: string }> {
    return this.request<{ message: string; status: string }>('/qr/test');
  }
}

export const apiService = new APIService();
